import { SL_WORKSPACE_PROFILE } from '@app/sl-workspace/profile';
import { ENABLE_EMAIL } from '@core/constant/featureFlags';
import { Show, Suspense } from 'solid-js';
import { EmailCard } from './Email';
import { GitHubCard } from './GitHub';
import { IntegrationsSection } from './Integrations';
import {
  SettingsCard,
  SettingsPage,
  SettingsRow,
  SettingsSection,
} from './primitives';

/**
 * Consolidated "Connections" page: one card per external account the user can
 * link (Gmail, GitHub), plus the agent's MCP integrations — so everything
 * the workspace is connected to lives in one place.
 */
export function ConnectedAccounts() {
  return (
    <SettingsPage
      title="Conexões"
      description="Conecte apenas as contas e fontes aprovadas para o SL Workspace."
    >
      <SettingsSection title="Contas">
        <div class="flex flex-col gap-3">
          <Show when={ENABLE_EMAIL}>
            <Suspense>
              <EmailCard />
            </Suspense>
          </Show>
          <Show
            when={
              !SL_WORKSPACE_PROFILE.enabled ||
              SL_WORKSPACE_PROFILE.capabilities.githubPersonalOauth
            }
            fallback={
              <SettingsCard>
                <SettingsRow
                  label="GitHub App"
                  description="A integração da SL usará somente leitura e repositórios selecionados."
                >
                  <span class="text-xs text-ink-muted">
                    Aguardando configuração aprovada
                  </span>
                </SettingsRow>
              </SettingsCard>
            }
          >
            <Suspense>
              <GitHubCard />
            </Suspense>
          </Show>
        </div>
      </SettingsSection>
      <Show
        when={
          !SL_WORKSPACE_PROFILE.enabled ||
          SL_WORKSPACE_PROFILE.capabilities.externalMcpConnect
        }
        fallback={
          <SettingsSection title="Fontes governadas">
            <SettingsCard>
              <SettingsRow
                label="Notion"
                description="Coleta unidirecional, somente leitura e limitada às páginas aprovadas."
              >
                <span class="text-xs text-ink-muted">
                  Aguardando conexão interna aprovada
                </span>
              </SettingsRow>
            </SettingsCard>
          </SettingsSection>
        }
      >
        <Suspense>
          <IntegrationsSection />
        </Suspense>
      </Show>
    </SettingsPage>
  );
}
